import { useMemo } from 'react';
import { HELP_DESK_FILTERS_SLUGS } from '@ubeya/shared-web/constants';

const useHelpDeskFilterParams = (filters) =>
  useMemo(() => {
    const basic = filters?.basic ?? [];
    const branchFilter = basic.find((f) => f.slug === HELP_DESK_FILTERS_SLUGS.BRANCHES);
    const categoryFilter = basic.find((f) => f.slug === HELP_DESK_FILTERS_SLUGS.CATEGORIES);
    const assigneeFilter = basic.find((f) => f.slug === HELP_DESK_FILTERS_SLUGS.ASSIGNEES);
    const priorityFilter = basic.find((f) => f.slug === HELP_DESK_FILTERS_SLUGS.PRIORITY);

    const categoryValue = categoryFilter?.value;
    const categoryIds = Array.isArray(categoryValue)
      ? categoryValue.map((item) => Number(item?.categoryId || item)).filter(Number.isFinite)
      : undefined;

    const assigneeValue = assigneeFilter?.value;
    const assignedAdminIds = Array.isArray(assigneeValue)
      ? assigneeValue.map((item) => item?.adminId ?? null)
      : undefined;

    const priorityValue = priorityFilter?.value;
    const priorities = Array.isArray(priorityValue) ? priorityValue : undefined;

    return {
      branchIds: Array.isArray(branchFilter?.value) ? branchFilter.value : undefined,
      categoryIds: categoryIds?.length ? categoryIds : undefined,
      assignedAdminIds: assignedAdminIds?.length ? assignedAdminIds : undefined,
      priorities: priorities?.length ? priorities : undefined
    };
  }, [filters]);

export default useHelpDeskFilterParams;
